// extracted by mini-css-extract-plugin
export default {"input":"All-News_input__zZA1S","imageUrl":"All-News_imageUrl__TGHzW","tag":"All-News_tag__4rS65","views":"All-News_views__oVRlt"};